import { FC } from 'react';
import * as S from './styled';

const Spinner: FC<{ disabled?: boolean; variant: 'contained' | 'outlined'; style?: any }> = ({
  disabled = false,
  variant,
  style = {},
}) => {
  return (
    <S.SpinnerWrapper style={style}>
      <S.SpinnerSvg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        disabled={disabled}
        className={variant}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.2C12.4418 1.2 12.8 1.55817 12.8 2V6C12.8 6.44183 12.4418 6.8 12 6.8C11.5581 6.8 11.2 6.44183 11.2 6V2C11.2 1.55817 11.5581 1.2 12 1.2Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.6657 4.33431C19.9781 4.64673 19.9781 5.15327 19.6657 5.46569L16.7657 8.36569C16.4533 8.67811 15.9468 8.67811 15.6343 8.36569C15.3219 8.05327 15.3219 7.54673 15.6343 7.23432L18.5343 4.33432C18.8468 4.0219 19.3533 4.0219 19.6657 4.33431Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2 12C17.2 11.5582 17.5581 11.2 18 11.2H22C22.4418 11.2 22.8 11.5582 22.8 12C22.8 12.4418 22.4418 12.8 22 12.8H18C17.5581 12.8 17.2 12.4418 17.2 12Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6343 15.6343C15.9468 15.3219 16.4533 15.3219 16.7657 15.6343L19.6657 18.5343C19.9781 18.8467 19.9781 19.3533 19.6657 19.6657C19.3533 19.9781 18.8468 19.9781 18.5343 19.6657L15.6343 16.7657C15.3219 16.4533 15.3219 15.9467 15.6343 15.6343Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 17.2C12.4418 17.2 12.8 17.5582 12.8 18V22C12.8 22.4418 12.4418 22.8 12 22.8C11.5581 22.8 11.2 22.4418 11.2 22V18C11.2 17.5582 11.5581 17.2 12 17.2Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.36566 15.6343C8.67808 15.9467 8.67808 16.4533 8.36566 16.7657L5.46566 19.6657C5.15324 19.9781 4.64671 19.9781 4.33429 19.6657C4.02187 19.3533 4.02187 18.8467 4.33429 18.5343L7.23429 15.6343C7.54671 15.3219 8.05324 15.3219 8.36566 15.6343Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.19995 12C1.19995 11.5582 1.55812 11.2 1.99995 11.2H5.99995C6.44178 11.2 6.79995 11.5582 6.79995 12C6.79995 12.4418 6.44178 12.8 5.99995 12.8H1.99995C1.55812 12.8 1.19995 12.4418 1.19995 12Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.33429 4.33431C4.64671 4.0219 5.15324 4.0219 5.46566 4.33431L8.36566 7.23431C8.67808 7.54673 8.67808 8.05327 8.36566 8.36569C8.05324 8.67811 7.54671 8.67811 7.23429 8.36569L4.33429 5.46569C4.02187 5.15327 4.02187 4.64673 4.33429 4.33431Z"
        />
      </S.SpinnerSvg>
    </S.SpinnerWrapper>
  );
};

export default Spinner;
